<script>
  import { auth } from '../state/auth.svelte.js';
  import { getSubscriptionTierLabel } from '../utils/subscription-ui.js';
  import {
    openPurchaseModal,
    openSubscriptionModal,
    SUBSCRIPTIONS_FEATURE_ENABLED
  } from '../state/billing.svelte.js';

  let open = $state(false);
  let wrapEl = $state(null);

  function formatNumber(num) {
    if (num >= 1000) return (num / 1000).toFixed(1) + 'k';
    const rounded = Math.round(num * 100) / 100;
    return rounded.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function toggle() {
    open = !open;
  }

  function onWindowClick(event) {
    if (open && wrapEl && !wrapEl.contains(event.target)) open = false;
  }

  function buySpark() {
    open = false;
    openPurchaseModal();
  }

  function managePlan() {
    open = false;
    openSubscriptionModal();
  }
</script>

<svelte:window onclick={onWindowClick} />

{#if auth.isLoggedIn}
  <div class="wrap" bind:this={wrapEl}>
    <button class="user-balance" onclick={toggle} aria-haspopup="menu" aria-expanded={open} title="Account & balance">
      {#if auth.isUnlimited}
        <span class="unlimited-badge">∞ {getSubscriptionTierLabel(auth.subscription)}</span>
      {:else}
        <div class="balance-item">
          <span class="balance-label">SPARK</span>
          <span class="balance-value">{formatNumber(auth.balance.spark)}</span>
        </div>
      {/if}
      <svg class="chevron" class:up={open} viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>

    {#if open}
      <div class="menu" role="menu">
        <div class="menu-balances">
          <div class="row"><span>Spark</span><strong>{formatNumber(auth.balance.spark)}</strong></div>
          <div class="row"><span>Premium Spark access</span><strong>{auth.balance.premiumSpark > 0 ? 'Available' : 'None'}</strong></div>
          <div class="row"><span>SOGNI</span><strong>{formatNumber(auth.balance.sogni)}</strong></div>
        </div>

        <button class="menu-item primary" role="menuitem" onclick={buySpark}>Buy Spark</button>

        {#if SUBSCRIPTIONS_FEATURE_ENABLED}
          {#if auth.isUnlimited}
            <button class="menu-item" role="menuitem" onclick={managePlan}>View plan & upgrades</button>
          {:else}
            <button class="menu-item" role="menuitem" onclick={managePlan}>Go Unlimited ∞</button>
          {/if}
        {/if}
      </div>
    {/if}
  </div>
{/if}

<style>
  .wrap { position: relative; }

  .user-balance {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    height: 36px;
    background: var(--color-surface);
    border-radius: 20px;
    border: 1px solid var(--color-border);
    font-size: 0.7rem;
    cursor: pointer;
    transition: border-color 0.2s;
  }

  .user-balance:hover { border-color: var(--color-primary); }

  .balance-item { display: flex; align-items: center; gap: 4px; }
  .balance-label { color: var(--color-text-muted); font-weight: 500; letter-spacing: 0.05em; }
  .balance-value { color: var(--color-primary); font-weight: 700; font-variant-numeric: tabular-nums; }

  .unlimited-badge {
    color: var(--color-primary);
    font-weight: 800;
    font-size: 0.72rem;
    letter-spacing: 0.02em;
  }

  .chevron { color: var(--color-text-muted); transition: transform 0.2s; }
  .chevron.up { transform: rotate(180deg); }

  .menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 200px;
    background: var(--color-bg);
    border: 1px solid var(--color-border);
    border-radius: 12px;
    box-shadow: var(--shadow-lg);
    padding: 8px;
    z-index: 200;
    display: flex;
    flex-direction: column;
    gap: 4px;
    animation: pop 0.12s ease;
  }

  @keyframes pop { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }

  .menu-balances {
    padding: 6px 10px 10px;
    border-bottom: 1px solid var(--color-border);
    margin-bottom: 4px;
  }

  .menu-balances .row {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    padding: 3px 0;
    color: var(--color-text-muted);
  }

  .menu-balances .row strong { color: var(--color-text); font-variant-numeric: tabular-nums; }

  .menu-item {
    text-align: left;
    background: none;
    border: none;
    padding: 9px 10px;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--color-text);
    cursor: pointer;
    transition: background 0.15s;
  }

  .menu-item:hover { background: var(--color-surface); }
  .menu-item.primary { color: var(--color-primary); }

  @media (max-width: 639px) {
    .user-balance { height: 32px; }
    .menu { min-width: 180px; }
  }
</style>
